import { Maybe } from '@aibees/shared/definition';

export function useErrorTooltipDisabled(
  value: any[],
  limitErrorShortMsg: Maybe<string>
) {
  return !(value.length > 0) && !!limitErrorShortMsg;
}
